import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createVoiceValidationSchema = Yup.object().shape({
  name: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
